import { Box, Divider, Stack, Typography } from "@mui/material";
import { MapPin } from "lucide-react";
import { colorPrimary } from "../../../theme";
import { SubmitButton } from "../../company/components/ButtonComponent";
import { AnunciosShopkeeper } from "../dto/ShopkeeperDTO";
import { CronometroRegressivo } from "./CronometroRegressivo";

export function AnuncioFooter({
  label,
  melhorOferta,
  compreAgora,
  onAction,
  id_concessionaria,
  logo,
  cidade,
  uf,
  tipoAnuncio,
  anuncio
}: {
  label: string;
  melhorOferta: string;
  compreAgora: string;
  actionLabel: string;
  onAction: () => void;
  id_concessionaria: number;
  logo: string;
  cidade: string;
  uf: string;
  tipoAnuncio: string;
  anuncio: AnunciosShopkeeper;
}) {
  return (
    <Box mt="auto" px={2} pb={2}>
      {/* Divider horizontal */}
      <Divider sx={{ mb: 2 }} />

      {/* Concessionária + localização */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent={"center"}
        spacing={2}
        mb={2}
      >
        {/* Logo */}
        <Box
          component="img"
          src={`https://canaldorepasse.com.br/cadastros/fotos/concessionaria/${id_concessionaria}/${logo}`}
          alt="Fiat Tecar"
          sx={{
            height: 40,
            objectFit: "contain",
            opacity: 0.85,
          }}
        />

        {/* Divider vertical */}
        <Divider orientation="vertical" flexItem  sx={{
          borderRightWidth: 2,
        }}/>

        {/* Localização */}
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <MapPin size={14} color={colorPrimary} />
          <Typography
            fontSize="0.75rem"
            fontWeight={700}
            color="text.secondary"
            textTransform="uppercase"
          >
            {cidade.toUpperCase()}/{uf.toUpperCase()}
          </Typography>
        </Stack>
      </Stack>
      {/* Divider horizontal */}
      <Divider sx={{ mb: 2,}} />

      {/* Preço */}
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Typography fontSize="0.85rem" color="text.secondary" fontWeight={800}>
          Melhor oferta:
        </Typography>
        <Typography fontWeight={800} color="primary.main" fontSize="1.2rem">
          {melhorOferta}
        </Typography>
      </Box>
      {/* Preço */}
        {tipoAnuncio ==='N'? (
        <Box display="flex" justifyContent="space-between" mb={2}>
            <Typography fontSize="0.85rem" color={tipoAnuncio === 'N' ? "text.secondary" : "transparent"} fontWeight={800}>
              {label}
            </Typography>
          <Typography fontWeight={800} color="primary.main" fontSize="1.2rem">
            {compreAgora}
          </Typography>
      </Box>
        ) : ( <Box minHeight={45}></Box>)}
      <CronometroRegressivo
        anuncio={anuncio}
      />
      {/* CTA */}
      <SubmitButton
      title="Ver detalhes"
      onClick={onAction}
      type="button"
      maxWidth={300}
      />
    </Box>
  );
}
